import { h, Component } from 'preact';
// import Store from 'store/store';

import { getData } from 'utils/dynamicData';
// import { joinClasses } from 'utils/utils';
import { renderCookieConsentLink } from 'utils/cookies';
import { track } from 'utils/tracking';

import PageLink from 'components/pageLink/pageLink';
import ShareIcons from 'components/shareIcons/shareIcons';

import s from 'components/footer/footer.sss';

export default class Footer extends Component {
	constructor(props) {
		super(props);
		this.state = {
			links: [],
			// legal: [],
		};

		this.renderLink = this.renderLink.bind(this);
		this.handleCookiePreferencesClick = this.handleCookiePreferencesClick.bind(this);
		this.onCacheInvalidate = this.onCacheInvalidate.bind(this);

		if (typeof window !== 'undefined') {
			this.loadData();
			// Listen for cache invalidation messages in preview mode
			window.addEventListener('message', this.onCacheInvalidate);
		}
	}

	componentDidUpdate(prevProps) {
		// Reload footer data when navigating to a different movie
		if (this.props.slug !== prevProps.slug) {
			this.loadData();
		}
	}

	componentWillUnmount() {
		if (typeof window !== 'undefined') {
			window.removeEventListener('message', this.onCacheInvalidate);
		}
	}

	onCacheInvalidate(e) {
		// Reload footer when navigation data cache is invalidated
		if (e.data?.type === 'invalidateCache' && e.data?.name === 'navigation') {
			this.loadData();
		}
	}

	async loadData() {
		try {
			const isMoviePage = !!(this.props.slug || window.__MOVIE__);
			const movieData = isMoviePage ? await getData(this.props.slug || window.__MOVIE__, 'movie') : null;
			const navigationData = await getData('navigation');

			// Get global footer links from Navigation & Legal section
			const globalFooterLinksRaw = navigationData?.footer?.links || [];

			// Convert navigation footer links to arrays per column, preserving order from Navigation & Legal
			const globalColumn1 = [];
			const globalColumn2 = [];

			globalFooterLinksRaw.forEach((column, columnIndex) => {
				if (Array.isArray(column)) {
					column.forEach((link) => {
						const linkObj = {
							name: link.name,
							destination: link.destination,
							external: /^https?:\/\//.test(link.destination),
						};
						if (columnIndex === 0) {
							globalColumn1.push(linkObj);
						} else {
							globalColumn2.push(linkObj);
						}
					});
				}
			});

			// Add custom links per-movie (appear after global links in each column)
			const customColumn1 = [];
			const customColumn2 = [];

			if (isMoviePage && movieData?.footer?.customLinks) {
				const customFooterLinks = movieData.footer.customLinks;

				// Sort custom links by order and organize by column
				const sortedCustomLinks = Object.values(customFooterLinks).sort((a, b) => (a.order || 0) - (b.order || 0));

				sortedCustomLinks.forEach(link => {
					const linkObj = {
						name: link.name,
						destination: link.destination,
						external: /^https?:\/\//.test(link.destination),
						movie: movieData, // Pass movie data for potential use in PageLink
					};
					if (link.column === 1) {
						customColumn1.push(linkObj);
					} else if (link.column === 2) {
						customColumn2.push(linkObj);
					}
				});
			}

			// Combine global and custom links per column (globals first, then custom)
			const column1 = [...globalColumn1, ...customColumn1];
			const column2 = [...globalColumn2, ...customColumn2];

			const links = [column1, column2];

			// Get social links from navigation data
			const socialLinksRaw = navigationData?.footer?.social || [];
			const socials = socialLinksRaw.map(social => ({
				id: social.id || social.name?.toLowerCase(),
				name: social.name,
				destination: social.destination,
			}));

			// Get legal text from navigation data
			const legal = navigationData?.footer?.legal || '© 2025 Focus Features. A Comcast Company.';

			this.setState({ legal, links, socials });
		} catch (err) {
			console.error(err);
		}
	}

	onLinkClick(e) {
		track('footer', 'footer-nav-click', e.currentTarget.textContent);
	}

	handleCookiePreferencesClick(e) {
		e.preventDefault();
		try {
			if (typeof window !== 'undefined' && window.OneTrust && window.OneTrust.ToggleInfoDisplay) {
				window.OneTrust.ToggleInfoDisplay();
			} else {
				console.warn('OneTrust not available');
			}
		} catch (error) {
			console.error('Error opening cookie preferences:', error);
		}
	}

	renderLink(link) {
		if (!link?.name) return;
		if (!link.destination) {
			return <span>{link.name}</span>;
		}

		if (link.destination === 'cookies') {
			return renderCookieConsentLink(link.name);
		}
		if (/^https?:\/\//i.test(link.destination)) {
			return (
				<a href={link.destination} target="_blank" rel="noopener noreferrer" onClick={this.onLinkClick}>
					{link.name}
				</a>
			);
		}
		return (
			<PageLink to={link.destination} movie={link.movie} onClick={this.onLinkClick}>
				{link.name}
			</PageLink>
		);
	}

	render(props, state) {
		return (
			<footer class={s.wrapper}>
				<div class={s.linksWrapper}>
					{state.links.map((section) => (
						<div class={s.links}>{section.map(this.renderLink)}</div>
					))}
					<div class={s.copyright}>{this.state.legal}</div>
				</div>
				<div class={s.shareWrapper}>
					Connect with Focus Features
					<ShareIcons class={s.share} links={state.socials} tracking="footer-social-click" />
				</div>
			</footer>
		);
	}
}
